import React from 'react';
import TabbedSection from '../../components/TabbedSection';
import BgBondRegister from './bg/BgBondRegister';
import BankMaster from './bg/BankMaster';
import BankLimitMaster from './bg/BankLimitMaster';
import CashMarginRegister from './bg/CashMarginRegister';
import BankWiseUtilization from './bg/BankWiseUtilization';
import BgBondReports from './bg/BgBondReports';

const BankGuarantees = ({ onViewThread }) => {
  const tabs = [
    { key: 'register', label: 'BG / Bond Register', content: <BgBondRegister onViewThread={onViewThread} /> },
    { key: 'banks', label: 'Bank Master', content: <BankMaster /> },
    { key: 'limits', label: 'Bank Limit Master', content: <BankLimitMaster /> },
    { key: 'cash', label: 'Cash Deposit / Margin Register', content: <CashMarginRegister /> },
    { key: 'utilization', label: 'Bank-wise Utilization', content: <BankWiseUtilization /> },
    { key: 'reports', label: 'BG / Bond Reports', content: <BgBondReports /> },
  ];

  return (
    <div>
      <div className="section-header">
        <h2>BG / Insurance Bonds</h2>
      </div>
      <TabbedSection tabs={tabs} />
    </div>
  );
};

export default BankGuarantees;
